import { useState } from 'react';
import { Link } from 'react-router-dom';

interface Country {
  id: number;
  name: string;
  imageUrl: string;
  slug: string;
}

const DestinationItem: React.FC<{ country: Country }> = ({ country }) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  // Placeholder image
  const placeholderImage = '/Continent/sub-preloaded.webp';

  return (
    <div className="shadow-md rounded-lg overflow-hidden transition-shadow duration-300 hover:shadow-md hover:scale-105">
      <Link to={`/destinations/${country.slug}`} className="block">
        <div className="relative pb-3/4 h-52 overflow-hidden group">
          <img
            className={`h-full w-full object-cover transform transition-transform duration-300 ease-in-out group-hover:scale-110 ${isImageLoaded ? '' : 'hidden'}`}
            src={country.imageUrl}
            alt={country.name}
            onLoad={() => setIsImageLoaded(true)}
          />
          {!isImageLoaded && (
            <img
              className="h-full w-full object-cover"
              src={placeholderImage}
              alt="Loading placeholder"
            />
          )}
        </div>
        <div className="p-4">
          <h3 className="font-bold text-underline text-sm">{country.name}</h3>
        </div>
      </Link>
    </div>
  );
};

export default DestinationItem;
